type SegmentArchiveAction = 'archive' | 'restore';

type ConfirmDialogContent = {
  title: string;
  describe: (segmentName: string) => string;
  confirmLabel: string;
};

type SegmentDetailsTab = { id: string; label: string; value: string; disabled?: boolean };

export const SEGMENT_DETAILS_CONFIRM_DIALOG_CONTENT: Record<SegmentArchiveAction, ConfirmDialogContent> = {
  archive: {
    title: 'Archiver le segment',
    describe: (segmentName) =>
      `Le segment « ${segmentName} » ne sera plus proposé aux points de livraison, et pourra être restauré.`,
    confirmLabel: 'Archiver',
  },
  restore: {
    title: 'Restaurer le segment',
    describe: (segmentName) => `Le segment « ${segmentName} » reviendra inactif.`,
    confirmLabel: 'Restaurer',
  },
};

export const SEGMENT_DETAILS_TABS: SegmentDetailsTab[] = [
  { id: 'statistics', label: 'Statistiques', value: 'statistics', disabled: true },
  { id: 'informations', label: 'Informations', value: 'informations' },
  { id: 'invoicing', label: 'Factures', value: 'invoicing' },
];

const DEFAULT_SEGMENT_DETAILS_TAB = 'informations';

export const resolveSegmentDetailsTab = (requestedTab: string | null): string =>
  SEGMENT_DETAILS_TABS.find((tab) => tab.id === requestedTab && !tab.disabled)?.id ?? DEFAULT_SEGMENT_DETAILS_TAB;
